import { EnvironmentProviders, makeEnvironmentProviders } from "@angular/core";
import { UNLEASH_CONFIG } from "@karelics/angular-unleash-proxy-client";

import { unleashConfigFactory } from "./unleash-config.factory";

export const provideUnleashConfig = (): EnvironmentProviders => {
  return makeEnvironmentProviders([
    {
      provide: UNLEASH_CONFIG,
      useFactory: unleashConfigFactory,
    },
  ]);
};
